module.exports = "/_next/static/images/alabama-802011e2ebdd17a86dbda62fb014ea48.svg";